var map = {
	"./texts.de-DE.ts": [
		690,
		690
	],
	"./texts.el-GR.ts": [
		877,
		877
	],
	"./texts.es-ES.ts": [
		531,
		531
	],
	"./texts.fr-FR.ts": [
		820,
		820
	],
	"./texts.it-IT.ts": [
		667,
		667
	],
	"./texts.ro-RO.ts": [
		10,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 844;
module.exports = webpackAsyncContext;